import { render, staticRenderFns } from "./default-empty-layout.vue?vue&type=template&id=16236c3d"
import script from "./default-empty-layout.vue?vue&type=script&lang=js"
export * from "./default-empty-layout.vue?vue&type=script&lang=js"
import style0 from "./default-empty-layout.vue?vue&type=style&index=0&id=16236c3d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports